import React from 'react';
import AssetViews from '../../components/assetcomponents/AssetViews';

function AssetView() {
    
    return (
        <>
            {/*Dynamic content goes here */}
            <AssetViews />
        </>
    )
};

export default AssetView;